import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DownpaymentsService {
  constructor(private http: HttpClientService) {}

  public index(application_id: number): Observable<any> {
    return this.http
      .get("/api/applications/" + application_id + "/downpayments")
      .pipe(tap((_) => console.log("DownpaymentsService.index: Ok.")));
  }

  public create(downpayment): Observable<any> {
    const options = {
      downpayment: downpayment,
    };
    return this.http
      .post("/api/applications/" + downpayment.application_id + "/downpayments", options)
      .pipe(tap((_) => console.log("DownpaymentsService.create: Ok.")));
  }

  public update(downpayment): Observable<any> {
    const options = {
      downpayment: downpayment,
    };
    return this.http
      .put("/api/downpayments/" + downpayment.id, options)
      .pipe(tap((_) => console.log("DownpaymentsService.update: Ok.")));
  }

  public destroy(downpayment): Observable<any> {
    return this.http
      .delete("/api/downpayments/" + downpayment.id)
      .pipe(tap((_) => console.log("DownpaymentsService.destroy: Ok.")));
  }

  public getAll(filters): Observable<any> {
    let options = {
      params: filters,
    };
    return this.http
      .get("/api/downpayments/all", options)
      .pipe(tap((_) => console.log("DownpaymentsService.getAll: Ok.")));
  }
}
